import React from 'react';
import type { CookbookContainerCoreProps } from '@gov-nx/ui/types';

export const CookbookContainer = ({
	children,
	label,
}: CookbookContainerCoreProps) => (
	<ul
		className="gov-list--plain flex flex-col gap-(--templates-margin-s)"
		aria-label={label}>
		{children}
	</ul>
);
